export default __webpack_public_path__ + "static/content-mobile-img-c2cd32a700188ceed6c06ad36f0446d7.png";